import { Typography } from "@mui/material";
import TypingText from "./framer/TypingText";

type Props = {
  title: string;
};

const PageHeader = ({ title }: Props) => {
  return (
    <Typography variant="h4" sx={{ fontFamily: "inherit" }}>
      <TypingText
        baseText={title}
        duration={2}
        delay={0}
        repeat={0}
        backgroundColor="black"
        height={"2rem"}
        isCursorBlinker={false}
      />
    </Typography>
  );
};

export default PageHeader;
